module.exports = __webpack_public_path__ + "img/avatar-s-9.397f0acd.jpg";